import React from 'react';
import '../styles.scss';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useNumberFormatter } from '../../../../hooks/useNumberFormatter';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    barColorPrimary: {
        backgroundColor: '#236BFF',
        borderRadius: 8
    },
    colorPrimary: {
        backgroundColor: '#D0D5E0',
        borderRadius: 8
    },
});

interface chartProps {
    completed: number;
    totalAmount: number;
    disbursmentAmount: number;
    format?: string;
}

const ChartProgressBar: React.FC<chartProps> = ({ completed, totalAmount, disbursmentAmount, format }) => {
    const { t } = useTranslation();
    const { formatMillions } = useNumberFormatter();
    const pendingAmount = totalAmount - disbursmentAmount || 0;
    const classes = useStyles();

    return (
        <div className='c-progress-bar'>
            <LinearProgress
                className='linear-chart'
                variant="determinate"
                value={completed}
                style={{ width: '100%' }}
                classes={{
                    barColorPrimary: classes.barColorPrimary,
                    colorPrimary: classes.colorPrimary,
                }}
            />

            <div className='c-linear_porcent-data'>
                <div className='content-data'>
                    <p className='initial-status-text'>{t('one_pager_report.disbursed')}</p>
                    <div className='initial-data-content'>
                        <div className="percent">
                            {completed} %
                        </div>
                        <div className='amount'>
                            {formatMillions(disbursmentAmount)} MM {format}
                        </div>
                    </div>
                </div>

                <div className='content-data'>
                    <p className='pending-status-text'>{t('one_pager_report.pending')}</p>
                    <div className='pending-data-content'>
                        <div className="percent">
                            {100 - completed} %
                        </div>
                        <div className='amount'>
                            {formatMillions(pendingAmount)} MM {format}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChartProgressBar;